import { G2ComparisonType } from '../components/G2Comparison'
import { AlternativeType } from '../types'
import WorkatoLogo from './images/workato-logo.svg'
import WorkatoIcon from './images/workato-icon.svg'

export const linkToG2 = 'https://www.g2.com/compare/integration-app-vs-workato'
export const g2Comparison: G2ComparisonType = {
  name: 'Workato Embedded',
  logo: WorkatoLogo.src,
  stars: 4.5,
  reviews: 527,
  markerSegment: (
    <>
      <b>Mid-Market</b> (42.8% of reviews)
    </>
  ),
  entryLevelPricing: <>No pricing available</>,
}

export const alternative: AlternativeType = {
  name: 'Workato Embedded',
  logo: WorkatoLogo,
  icon: WorkatoIcon,
}
